import { render, staticRenderFns } from "./NewVoluntaryProgram.vue?vue&type=template&id=25f77be4"
import script from "./NewVoluntaryProgram.vue?vue&type=script&lang=ts"
export * from "./NewVoluntaryProgram.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports